import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Paper,
  Chip,
  Skeleton,
  AppBar,
  Toolbar,
  Stepper,
  Step,
  StepLabel,
  Divider,
  Tooltip,
  Stack,
} from "@mui/material";
import Swal from "sweetalert2";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import axios from "axios";
import toast from "react-hot-toast";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import { fetchOrganizations } from "../../../Apis/Organization-apis";
import { MAIN_URL } from "../../../Configurations/Urls";
import { useNavigate,useLocation } from "react-router-dom";
import { LogOutIcon } from "lucide-react";

const steps = ["Select Organization", "Mark Attendance"];

const OrganizationChangePage = () => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userData, login } = useAuthStore();
  const org = userData?.organization;
  const navigate = useNavigate();
  const { logout } = useAuthStore();


    const location = useLocation()
    const itemdata = location.state || {}


    console.log("data item comin is ", itemdata)

  const handleOrganizationClick = async (item) => {
    try {
      console.log("items", item);


      

      navigate("/", { state: item });
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session Expired!");
        navigate("/login", { replace: true });
      } else {
        console.error("Failed to switch organization:", error);
        toast.error(
          error.response?.data?.error || "Failed to update organization"
        );
      }
    }
  };

const handleLogout = () => {
  Swal.fire({
    title: "Are you sure?",
    text: "You want to logout?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, logout",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const token = localStorage.getItem("token");
        
        await axios.get(`${MAIN_URL}/api/auth/logout`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        logout();
        localStorage.removeItem("token"); // Only remove the token
        Swal.fire("Logged out!", "You have been logged out.", "success");
        navigate("/login");
      } catch (error) {
        // For any error (including 401), remove token and redirect to login
        console.error("Logout failed:", error);
        logout();
        localStorage.removeItem("token");
        navigate("/login");
      }
    }
  });
};

  useEffect(() => {
    let isMounted = true; 

    if (org?.organization_id && isMounted) {
      setLoading(true);
      fetchOrganizations(org?.client_id)
        .then((data) => {
          if (isMounted) {
            const formatted = data?.organizations.map((item) => ({
              ...item,
            }));
            setOrganizations(formatted);
          }
        })
        .catch(() => {
          if (isMounted) toast.error("Failed to fetch organizations");
        })
        .finally(() => {
          if (isMounted) setLoading(false);
        });
    }

    return () => {
      isMounted = false; 
    };
  }, [org]);

return (
  <Box sx={{ minHeight: "100vh", bgcolor: "#f5f7fb" }}>
    {/* Top Right Logout Button */}
    <Stack
      direction="row"
      spacing={2}
      sx={{
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: 1300,
        flexWrap: "wrap",
        justifyContent: "flex-end",
        "@media (max-width:600px)": {
          position: "static",
          justifyContent: "center",
          mt: 1,
        },
      }}
    >
      <Button
        variant="contained"
        color="error"
        startIcon={<LogOutIcon />}
        onClick={handleLogout}
        sx={{
          textTransform: "none",
          fontWeight: "bold",
          borderRadius: "8px",
          padding: "6px 16px",
          boxShadow: 2,
          "&:hover": {
            backgroundColor: "#d32f2f",
            boxShadow: 3,
          },
          fontSize: { xs: "0.8rem", sm: "0.9rem" },
        }}
      >
        Logout
      </Button>
    </Stack>

    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      {/* Page Title */}
      <Typography
        variant="h4"
        fontWeight="bold"
        gutterBottom
        textAlign="center"
        sx={{
          fontSize: { xs: "1.3rem", sm: "1.7rem", md: "2rem" },
          background: "linear-gradient(45deg, #1976d2, #42a5f5)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Select Your Organization
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        textAlign="center"
        gutterBottom
        sx={{
          fontSize: { xs: "0.85rem", sm: "1rem" },
        }}
      >
        Choose the organization where you want to mark attendance.
      </Typography>

      {/* Loader State */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // ✅ Center loader cards initially
            gap: { xs: 2, sm: 3 },
            mt: 3,
            flexWrap: { xs: "wrap", sm: "nowrap" },
            overflowX: { xs: "visible", sm: "auto" },
            pb: 1,
            "&::-webkit-scrollbar": {
              height: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#90caf9",
              borderRadius: "4px",
            },
          }}
        >
          {Array.from({ length: 6 }).map((_, i) => (
            <Card
              key={i}
              sx={{
                borderRadius: 3,
                backdropFilter: "blur(8px)",
                background: "rgba(255,255,255,0.4)",
                boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                p: 2,
                width: { xs: "100%", sm: 220 },
                maxWidth: { xs: "320px" },
                flexShrink: 0,
              }}
            >
              <Skeleton
                variant="rectangular"
                height={120}
                sx={{ borderRadius: 2 }}
              />
              <Skeleton variant="text" sx={{ mt: 1, width: "80%" }} />
              <Skeleton variant="text" sx={{ width: "60%" }} />
            </Card>
          ))}
        </Box>
      ) : organizations?.length === 0 ? (
        <Paper
          sx={{
            p: { xs: 3, sm: 5 },
            textAlign: "center",
            mt: 5,
            borderRadius: 4,
            boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
          }}
        >
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ fontSize: { xs: "1rem", sm: "1.2rem" } }}
          >
            No organizations found.
          </Typography>
        </Paper>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // ✅ Cards will be centered initially
            gap: { xs: 2, sm: 3 },
            mt: 2,
            flexWrap: { xs: "wrap", sm: "nowrap" },
            overflowX: { xs: "visible", sm: "auto" },
            pb: 1,
            "&::-webkit-scrollbar": {
              height: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#90caf9",
              borderRadius: "4px",
            },
          }}
        >
          {organizations?.map((item) => {
            return (
              <Tooltip
                key={item?.organization_id}
                title={item?.organization_name}
                arrow
              >
                <Card
                  onClick={() => handleOrganizationClick(item)}
                  sx={{
                    cursor: "pointer",
                    borderRadius: 3,
                    textAlign: "center",
                    p: 2,
                    width: { xs: "100%", sm: 220 },
                    maxWidth: { xs: "320px" },
                    flexShrink: 0,
                    transition: "all 0.25s ease-in-out",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 10px 28px rgba(0, 0, 0, 0.18)",
                    },
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{
                        textTransform: "capitalize",
                        mb: 0.5,
                        color: "#212121",
                        fontSize: { xs: "0.95rem", sm: "1rem" },
                      }}
                    >
                      {item?.organization_name}
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      sx={{
                        mb: 1,
                        fontSize: { xs: "0.8rem", sm: "0.9rem" },
                      }}
                    >
                      {item.organization_short_name}
                    </Typography>
                  </CardContent>
                </Card>
              </Tooltip>
            );
          })}
        </Box>
      )}
    </Box>
  </Box>
);


};

export default OrganizationChangePage;
